import { Box, Button } from '@chakra-ui/react'

const ShowAddress = ({ onClick }: { onClick?: () => void }) => {
  return (
    <Box color='#8E919F' fontWeight='medium' mb='3'>
      No coordinates?{' '}
      <Button onClick={onClick} variant='link'>
        Add address
      </Button>
    </Box>
  )
}

export { ShowAddress }
